import { BRAND } from "@/lib/content";

// "Add to contacts": a vCard the visitor's phone or mail app imports in one tap.
export function downloadVCard() {
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `FN:${BRAND.name}`,
    `ORG:${BRAND.name}`,
    "TITLE:Legal concierge for creators",
    `EMAIL;TYPE=INTERNET,WORK:${BRAND.email}`,
    `URL:https://${BRAND.consumer_domain}/start`,
    "NOTE:Send one request for any creator legal problem: brand deals\\, platform bans\\, trademarks\\, business setup. Not a law firm.",
    "END:VCARD",
  ];
  const blob = new Blob([lines.join("\r\n") + "\r\n"], { type: "text/vcard" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Upload-Counsel.vcf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
